import { MAX_SEGMENTS_IN_GROUP } from "../SegmentsAnalysisHelper";

export enum SegmentsTypeByUsage {
    singleSegment,
    groupSegment,
    industrySegments,
}

export const ROWS_PER_PAGE = 10;

export const MAX_SELECTED_ROWS = MAX_SEGMENTS_IN_GROUP;
